import React from "react";

const style = {
    textAlign: 'center',
    padding: '2rem 1rem',
    minHeight: '75vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // background: 'rgb(213,213,213)',
    background: 'radial-gradient(circle, rgba(213,213,213,1) 0%, rgba(255,255,255,1) 100%)'
}

const Page404 = () => {
    return (
        <div style={style}>
            <h1 style={{fontSize: '4rem', fontWeight: 'bold'}}>404</h1>
            <h4>Page not found</h4>
        </div>
    )
}

export default Page404;